<div class="project-overview-container" appUserManual [userManualKey]="'project-overview'">
  @if (progress$ | async; as progress) {
    <div class="global-progress" *ngIf="showProgressBar">
      <div class="label">Loading checksheets... {{ progress.loaded }}/{{ progress.total }} ({{ progress.percent }}%)</div>
      <div class="bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="progress.percent">
        <div class="bar-fill" [style.width.%]="progress.percent"></div>
      </div>
    </div>
  }

  <app-project-overview-view></app-project-overview-view>
</div>
